import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Asset search stats DTO
 */
@CaslSubject(AppSubjectEnum.ASSET)
export class AssetSearchStatsDto extends BaseStatsDto {}
